
import React from "react";
import { renderToString } from 'react-dom/server';
import SvgSprite from "../../../Utils/SvgSprite";
// import SvgSprite from "championship/src/components/Utils/SvgSprite";

const $ = window.jQuery

// console.log('window.jQuery', $)


function SearchSelectInner({id}){
    return (
        <div className="select-search js-select-search -better" id={id} data-url="/players/search">
            <input type="hidden" name="user" data-name=""
                   className="select-search__hidden" />
            <div className="input-wrap">
                <span className="input_addon-before hide"></span>
                <input type="text" className="select-search__input input"
                       placeholder="Введите имя игрока"/>
                {/* <SvgSprite id="search" section="form" /> */}
            </div>
            <div className="select-search__popper">
                <div className="select-search__loading">
                    <div className="select-search__loading-icon">
                        <img src="/static/championship/image/loading.svg"
                             alt="Loading" />
                    </div>
                </div>
                <div className="select-search__list"></div>
                <div className="select-search__item hide" data-item-id>
                    <div class="image player__img_list">
                        <img className="" src="https://placehold.co/24" />
                        <div className="image-undefined">
                            <SvgSprite 
                                id='image_undefined'
                                section='defaults'
                            />
                        </div>
                        <div class="image__marks"></div>
                    </div>
                    <div data-item-field="name"></div>
                </div>
                <div class="select-search__notfound">
                        Ничего не найдено
                </div>      
            </div>
        </div>
    )
}


let current_search_select_id = -999
class SearchItem extends React.Component{

    constructor(props){
        super(props)
        this.id = props.id ?? 'search_select_' + current_search_select_id++;
    }
    componentDidMount(){

        this.initSelect()
    }

    addItem(data){
        const participants = this.props.ctx.get(this.props.atom)
        const index = participants.findIndex((item) => item.id == this.props.source_id)
        participants[index][this.props.prop] = data
        this.props.atom(this.props.ctx, [...participants])
        // console.log('this.props.ctx', this.props.ctx.get(this.props.atom))
    }

    componentWillUnmount(){

    }

    // shouldComponentUpdate(){
    //     return false
    // }

    setInputValue(){
        let name = [
            this.props.source?.last_name,
            this.props.source?.first_name,
            this.props.source?.middle_name,
        ].join(' ')
        name = name.trim()
        if(!name){
            name = this.props.source?.name
        }

        this.$input.val(name)
    }

    initSelect(){
        const $search_select = $(`#${this.id}`)

        // console.log($search_select)

        this.$input = $search_select.find('.select-search__input.input')
        
        const $popper = $search_select.find('.select-search__popper');

        this.setInputValue()


        $search_select.click(function(event){
            event.stopPropagation()
        })

        this.hide_bounded_callback = function(){
            $popper.hide()
            // $search.val($input.data('name'))
            this.setInputValue()
        }.bind(this)
        document.addEventListener('click', this.hide_bounded_callback)

        $search_select.selectSearch({
            should_hide_on_unfocus: false,
            onSelect: (data, $select) => {
                this.addItem(data)
                // $select.find('.select-search__input.input').val('')
            },
            onListRender: (list) => {
                // console.log('onListRender', list)
                list.forEach((el, i) => {
                  const $el = $(el)
                  const data = $el.data('item')
                  console.log('onListRender', data)

                  const $image = $el.find('.image')
                  const $marks = $el.find('.image__marks')

                  if(data.verified){
                    
                    $marks.append(renderToString(
                        <div className="image__mark -check_mark">
                            <SvgSprite id="check_mark" />
                        </div>
                    ))
                    // $marks.append(`<div class="image__mark -check_mark"><div class="svg-icon"><svg><use href="/static/championship/image/svg/sprites/common.svg#check_mark"></use></svg></div></div>`)
                  }

                  if (data.image) {
                    $el.find('img').attr('src', data.image)
                  }else{
                    $image.addClass('-undefined')
                  }
                })
              }
        })
    }
    render(){
        return (
            <div class="">
                <SearchSelectInner id={this.id} />
            </div>
        )
    }
}


export default SearchItem